<script>
export let registration;


import tippy from 'sveltejs-tippy';
import dayjs from 'dayjs';


import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();



let player_name = registration.player.first_name + ' ' + registration.player.last_name;
// let player_emails = registration.player.guardian_email;


const positions = {
	'forward': 'Forward',
	'defenceman': 'Defence',
	'goalie': 'Goalie',
}


let registration_position = '';
if (registration.position) {
	registration_position = positions[registration.position];
}



let registration_paid;

if (registration.gross_outstanding === 0) {
	registration_paid = 'Fully';
} else if (registration.gross > 0) {
	registration_paid = 'Partially';
} else {
	registration_paid = 'No';
}


let gross_outstanding = '';
if (registration.gross_outstanding !== null) {
	gross_outstanding = '$' + (registration.gross_outstanding).toFixed(2);
}


let player_birth_year = ''; 
if (registration.player.date_of_birth) {
	player_birth_year = dayjs(registration.player.date_of_birth).format('YYYY'); // '25/01/2019'
}


const props = {
	content: `Click to view more details for ${player_name}.`,
	allowHTML: true,
	placement: 'bottom',
	arrow: false,
}



function openRegistrationModal() {
	// dispatch('open_registration_modal', {
	// 	id: registration.id,
	// });
}

</script>



<style>

.registration-thumb {
	/* border... */
	/* padding */
	border: none;
	transition: all ease 0.225s;
}

.registration-thumb:hover {
	/*cursor: pointer;*/
	/*background: var(--bg-light);*/
}

</style>



<div class="panel-block registration-thumb" on:click={openRegistrationModal}>

	<div class="columns is-variable is-mobile is-2 is-vcentered">

		<div class="column is-3-desktop is-4-touch">
			<span>
				{player_name}
			</span>
		</div>

		<div class="column is-2-desktop is-4-touch">
			<span>
				{player_birth_year}
			</span>
		</div>

		<div class="column is-2-desktop is-hidden-touch">
			<span>
				{registration_position}
			</span>
		</div>

		<div class="column is-2-desktop is-4-touch">
			<span>
				{registration_paid}
			</span>
		</div>

		<div class="column is-3-desktop is-hidden-touch">
			<span>
				{gross_outstanding}
			</span>
		</div>


	</div>

</div>

